/* 

  following take defaultColumnState and localStorage Column state,
  based on whether columns are added or removed in defaultColumnState will set ColumnDefs

  It also has a helper function to merge defaultColumnState and localStorage Column state to preserve
  user's last actions (i.e. column state).

  IMPORTANT: the columnDefs could be nested in case of grouped column headings. This is the one that we supply to AG-grid
  but the persistedColumnDefs column state that we get from aggrid api always return flag list only.
  Thus, the additional logic in code to work with and maintain grouped column structure.

*/
export const handleColumnStateDifferencesWithLS = ({
  columnsList: columnDefs,
  columnsListLS: persistedColumnDefs,
  key = 'colId',
}) => {
  // Create a map of persisted columns for efficient lookup
  const persistedColsMap = persistedColumnDefs.reduce((acc, col) => ({ ...acc, [col[key]]: col }), {});

  // Process columns
  const processedColumnDefs = columnDefs.map((col) => {
    const persistedCol = persistedColsMap[col[key]];
    if (persistedCol) {
      // If there's a matching persisted column, override the properties
      return { ...col, ...persistedCol };
    }
    if (col.children) {
      // this is specifically for nested columns, when we have grouped heading and hence nested column definition
      // https://ag-grid.com/javascript-data-grid/column-groups/#group-defaults
      // If the column has children, process them
      const children = col.children.map((childCol) => {
        const persistedChildCol = persistedColsMap[childCol[key]];
        return persistedChildCol ? { ...childCol, ...persistedChildCol } : childCol;
      });
      return { ...col, children };
    }
    // If there's no matching persisted column and no children, return the column as is
    return col;
  });

  // reorder processedColumnDefs as per the order in persistedColumnDefs
  const reorderedColumnDefs = [];
  const processedColumnDefsFoundIndices = [];

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < persistedColumnDefs.length; i++) {
    const foundColumnOrColumnGroup = processedColumnDefs.find((column, processedIndex) => {
      let isFound = false;
      if (column[key] === persistedColumnDefs[i][key]) {
        isFound = true;
      }

      // also check if the item is column group
      if (column.children) {
        // if the column is group and already added because of already processed children then no need to add it
        if (processedColumnDefsFoundIndices.includes(processedIndex)) {
          return false;
        }
        isFound = column.children.find((child) => child[key] === persistedColumnDefs[i][key]);
      }
      if (isFound) {
        processedColumnDefsFoundIndices.push(processedIndex);
        return true;
      }
      return false;
    });

    if (foundColumnOrColumnGroup) {
      reorderedColumnDefs.push(foundColumnOrColumnGroup);
    }
  }
  // if there are any columns in columnDefs that are not found in persistedColumnDefs then add them at the end
  processedColumnDefs.forEach((column, processedIndex) => {
    if (!processedColumnDefsFoundIndices.includes(processedIndex)) {
      reorderedColumnDefs.push(column);
    }
  });

  return reorderedColumnDefs;
};
